import {
  useHovercardDismiss
} from "../__chunks/5WJWIOBD.js";
import "../__chunks/HRXPFA6C.js";
import "../__chunks/4GZAUH66.js";
import "../__chunks/O6CV6VRM.js";
import "../__chunks/P4RGQGTG.js";
import "../__chunks/LNHZLQEK.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/menu/menu-dismiss.ts
var useMenuDismiss = createHook((props) => {
  props = useHovercardDismiss(props);
  return props;
});
var MenuDismiss = createComponent((props) => {
  const htmlProps = useMenuDismiss(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuDismiss.displayName = "MenuDismiss";
}
export {
  MenuDismiss,
  useMenuDismiss
};
